// A WAV en el navegador, con el Web Audio API: MediaRecorder entrega webm/opus
// y Voxtral sólo acepta mp3 y wav. Mono y 16 kHz, de sobra para voz.

const FRECUENCIA = 16000;

/** Blob de audio (webm, mp4, lo que sea que el navegador grabe) -> Blob wav. */
export async function aWav(blob, frecuencia = FRECUENCIA) {
  const Contexto = window.AudioContext || window.webkitAudioContext;
  if (!Contexto) throw new Error('Este navegador no soporta Web Audio.');

  const contexto = new Contexto();
  let audio;
  try {
    audio = await contexto.decodeAudioData(await blob.arrayBuffer());
  } finally {
    contexto.close();
  }

  const muestras = await aMonoResampleado(audio, frecuencia);
  return new Blob([codificarWav(muestras, frecuencia)], { type: 'audio/wav' });
}

/** Mezcla a un canal y remuestrea, dejando que lo haga el propio navegador. */
async function aMonoResampleado(audio, frecuencia) {
  const Offline = window.OfflineAudioContext || window.webkitOfflineAudioContext;
  const cuadros = Math.max(1, Math.ceil(audio.duration * frecuencia));
  const offline = new Offline(1, cuadros, frecuencia);

  const fuente = offline.createBufferSource();
  fuente.buffer = audio;
  fuente.connect(offline.destination);
  fuente.start();

  const renderizado = await offline.startRendering();
  return renderizado.getChannelData(0);
}

/** Muestras float [-1, 1] -> ArrayBuffer con cabecera RIFF y PCM de 16 bits. */
function codificarWav(muestras, frecuencia) {
  const bytesPorMuestra = 2;
  const buffer = new ArrayBuffer(44 + muestras.length * bytesPorMuestra);
  const vista = new DataView(buffer);

  const texto = (offset, cadena) => {
    for (let i = 0; i < cadena.length; i += 1) {
      vista.setUint8(offset + i, cadena.charCodeAt(i));
    }
  };

  const bytesPorSegundo = frecuencia * bytesPorMuestra;

  texto(0, 'RIFF');
  vista.setUint32(4, 36 + muestras.length * bytesPorMuestra, true);
  texto(8, 'WAVE');
  texto(12, 'fmt ');
  vista.setUint32(16, 16, true);            // tamaño del bloque fmt
  vista.setUint16(20, 1, true);             // 1 = PCM sin comprimir
  vista.setUint16(22, 1, true);             // canales: mono
  vista.setUint32(24, frecuencia, true);
  vista.setUint32(28, bytesPorSegundo, true);
  vista.setUint16(32, bytesPorMuestra, true);
  vista.setUint16(34, 8 * bytesPorMuestra, true);
  texto(36, 'data');
  vista.setUint32(40, muestras.length * bytesPorMuestra, true);

  let offset = 44;
  for (let i = 0; i < muestras.length; i += 1) {
    // Recortar antes de escalar: un pico fuera de rango daría la vuelta y
    // sonaría como un chasquido.
    const v = Math.max(-1, Math.min(1, muestras[i]));
    vista.setInt16(offset, v < 0 ? v * 0x8000 : v * 0x7fff, true);
    offset += bytesPorMuestra;
  }

  return buffer;
}

